import * as CreateOfflineInvestorTypes from 'src/actions/project/offline-investor/create/Types';
import { CreateOfflineInvestorAction } from 'src/actions/project/offline-investor/create/CreateOfflineInvestor.actions';

export interface CreateOfflineInvestorState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: CreateOfflineInvestorState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function CreateOfflineInvestorReducer(state: CreateOfflineInvestorState = initialState,
                                             action: CreateOfflineInvestorAction): CreateOfflineInvestorState {
  switch (action.type) {
    case CreateOfflineInvestorTypes.CREATE_OFFLINE_INVESTOR_ATTEMPT:
      return {...state, loading: true, error: false};
    case CreateOfflineInvestorTypes.CREATE_OFFLINE_INVESTOR_SUCCESS:
      return {...state, loading: false, error: false};
    case CreateOfflineInvestorTypes.CREATE_OFFLINE_INVESTOR_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/project/offline-investor/CreateOfflineInvestorReducer.ts